module.exports = __webpack_public_path__ + "static/media/duka6.ec37b5c7.jpg";